import styled, { css } from 'styled-components';
import { themeGet } from '@styled-system/theme-get';
import { layout } from 'styled-system';
import Text from '../../../../shared/Text';

export const CAMPAIGN_WIDTH = '135';

export const Wrapper = styled.div`
  display: flex;
  margin: 24px;
  justify-content: flex-start;

  ${themeGet('mediaQueries.forExtraLargeUp')} {
    width: 1090px;
    margin: 24px auto 0;
  }
`;

export const CampaignWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 9px;
  width: ${CAMPAIGN_WIDTH}px;
  height: 103px;
  align-items: center;
  position: relative;
  cursor: pointer;
`;

export const ImageWrapper = styled.div`
  position: relative;
`;

export const TileImage = styled.img`
  ${layout};
  border-radius: 50%;
  border: 1px solid ${themeGet('colors.black.40')};
  padding: 4px;

  ${({ isSelected }) =>
    isSelected &&
    css`
      border: 2px solid ${themeGet('colors.primary.100')};
    `}
`;

export const CampaignText = styled(Text)`
  max-width: 100px;
  word-break: break-word;
  text-align: center;
  color: ${themeGet('colors.black.100')};
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;

  ${({ isSelected }) =>
    isSelected &&
    css`
      color: ${themeGet('colors.primary.100')};
    `}
`;

export const CampaignLabel = styled(Text)`
  position: absolute;
  top: 43px;
  width: 40px;
  left: calc(50% - 20px);
  border: 2px solid ${themeGet('colors.white')};
  border-radius: 4px;
  padding: 4px;
  color: ${themeGet('colors.white')};
  letter-spacing: 1px;
  background: ${themeGet('colors.black.80')};
  display: flex;
  align-items: center;
  justify-content: center;

  ${({ isSelected }) =>
    isSelected &&
    css`
      background: ${themeGet('colors.primary.100')};
    `}
`;

export const MenuIcon = styled(Text)`
  border-radius: 50%;
  height: 50px;
  width: 50px;
  margin: 4px;
  background: ${themeGet('colors.black.80')};
  color: ${themeGet('colors.white')};
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;

  ${({ isSelected }) =>
    isSelected &&
    css`
      background: ${themeGet('colors.primary.100')};
    `}

  &:after {
    content: '';
    position: absolute;
    border: 1px solid ${themeGet('colors.black.40')};
    padding: 4px;
    height: 58px;
    width: 58px;
    border-radius: 50%;

    ${({ isSelected }) =>
      isSelected &&
      css`
        border: 2px solid ${themeGet('colors.primary.100')};
      `}
  }
`;

export const OlderCampaignsMenu = styled.ul`
  background: ${themeGet('colors.white')};
  position: absolute;
  display: flex;
  flex-direction: column;
  top: 95px;
  right: 0;
  z-index: 3;
  border-radius: 8px;
  box-shadow: 0px 12px 40px rgba(37, 40, 43, 0.32);
`;

export const OlderCampaign = styled.li`
  padding: 5px 10px;
  width: 220px;
  height: 47px;
  display: flex;
  gap: 10px;
  cursor: pointer;
  align-items: center;

  &:first-child {
    border-radius: 8px 8px 0 0;
  }

  &:last-child {
    border-radius: 0 0 8px 8px;
  }

  &:hover {
    background: ${themeGet('colors.primary.10')};
  }
`;

export const MenuText = styled(Text)`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;
